import React, { Fragment } from "react";
import "./business-value.css";
import SectionContainer from "../../../components/landing/section-container";
import Amenity from "../../../components/landing/amenity";
import { Grid } from "@mui/material";

import PublicServiceImg from "../../../assets/public-services.png";
import WifiImg from "../../../assets/wifi.png";
import BedImg from "../../../assets/bed.png";
import KitchenImg from "../../../assets/kitchen.png";
import WashingZoneImg from "../../../assets/washing-zone.png";
import SecurityImg from "../../../assets/security.png";
import WalkingImg from "../../../assets/walking.png";
import PublicBusImg from "../../../assets/bus.png";
import ExerciseImg from "../../../assets/exercise.png";
import GroceryImg from "../../../assets/grocery.png";
import FarmerMarketImg from "../../../assets/farmer-market.png";
import CleaningImg from "../../../assets/cleaning.png";

function BusinessValuePage() {
  const amenities = [
    {
      description:
        "Agua, electricidad e internet incluidos en tu renta, sin preocuparte por costos adicionales.",
      title: "Servicios Incluidos",
      image: PublicServiceImg,
    },
    {
      description:
        "Internet de fibra óptica a 1000Mbps para estudiar y entretenerte sin interrupciones.",
      title: "Internet Alta Velocidad",
      image: WifiImg,
    },
    {
      description:
        "Solo necesitas traer tu ropa. Cuartos equipados para descansar y estudiar cómodamente.",
      title: "Cuarto Amoblado",
      image: BedImg,
    },
    {
      description:
        "Todos los utensilios provistos. Solo necesitas ingredientes y talento para cocinar.",
      title: "Cocina Equipada",
      image: KitchenImg,
    },
    {
      description: "Lavandería conveniente para tu comodidad.",
      title: "Lavandería",
      image: WashingZoneImg,
    },
    {
      description:
        "Cámaras de alta definición y vigilancia continua. Tu seguridad es nuestra prioridad.",
      title: "Seguridad 24/7",
      image: SecurityImg,
    },
    {
      description:
        "A menos de 12min caminando a UCR, Fidelitas, Ciencias y Artes, y Latina.",
      title: "Cercanía Universidades",
      image: WalkingImg,
    },
    {
      description:
        "Paradas de autobús a 3 min y estación de tren a 12 min caminando.",
      title: "Transporte Público",
      image: PublicBusImg,
    },
    {
      description:
        "A menos de 5 min caminando, visita dos parques cercanos o el gimnasio.",
      title: "Estilo de Vida Activo",
      image: ExerciseImg,
    },
    {
      description:
        "A menos de 15 min a pie de supermercados, panaderías, verdulerías, pulperías y zonas de comida.",
      title: "Cercanía Tiendas",
      image: GroceryImg,
    },
    {
      description:
        "Feria del Agricultor a 7 min caminando, con productos frescos y locales cada sábado.",
      title: "Feria del Agricultor",
      image: FarmerMarketImg,
    },
    {
      description:
        "Limpieza de zonas comunes cada 15 días para mantener un ambiente limpio y acogedor.",
      title: "Limpieza Quincenal",
      image: CleaningImg,
    },
  ];

  return (
    <SectionContainer id="business-value" title="Servicios">
      <Fragment>
        <Grid container spacing={1}>
          {amenities.map((value) => {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                sx={{ height: { xs: 200, lg: 250 }, textAlign: "center" }}
                key={value.title}
              >
                <Amenity
                  title={value.title}
                  description={value.description}
                  image={value.image}
                />
              </Grid>
            );
          })}
        </Grid>
      </Fragment>
    </SectionContainer>
  );
}

export default BusinessValuePage;
